<template>
  <div class="container">
    <h1 class="py-4">加盟店端末情報詳細</h1>
    <div v-if="show" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">企業識別コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.company_identification_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">企業ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.company_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">企業名</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.company_name }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">企業電話番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.company_phone }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">企業郵便番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.company_postcode }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">企業住所1</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.company_address1 }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">企業住所2</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.company_address2 }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">店舗識別コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.store_identification_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">店舗ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.store_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">店舗名</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.store_name }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">店舗電話番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.company_phone }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">店舗郵便番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.company_postcode }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">店舗住所1</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.company_address1 }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">店舗住所2</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.company_address2 }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">サービス開始日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.service_start_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">解約日付</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.cancellation_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">設置端末台数</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.terminals_number }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">端末ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.terminal_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">端末利用種別</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.terminal_type }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">端末利用開始日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.terminal_usage_start }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">端末利用終了日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.terminal_usage_end }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth ht100 flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">予備</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.other }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "MerchantTerminalDetails",
  mixins: [utils, master, sex, countries, prefs],
  data() {
    return {
      terminalId: "",
      show: false,
      show2: false,
      loading: true,
      data: [],
      db: firebase.firestore(),
    };
  },
  created: function() {
    this.terminalId = this.$route.query.terminalId.toString();
    this.loadData();
  },
  methods: {
    init() {
      this.show = false;
      this.show2 = false;
      this.key = this.key ? 0 : 1;
    },
    async loadData() {
      this.init();
      const doc = await this.db
        .collection("merchantTerminals")
        .doc(this.terminalId)
        .get();
      if (doc.exists) {
        this.data = doc.data();
        this.show = true;
        this.loading = false;
      }
    },
  },
};
</script>
